/**
 * 标签管理相关请求
 */
import request from "@/utils/request";

// 获取标签分组数据
export const tagSortTreeRequest = () => {
  return request.get('/api/v2/tag/sort/tree')
}

// 添加或编辑标签分组
export const upsertTagSortRequest = (data: any) => {
  return request.post('/api/v2/tag/sort/upsert', data)
}

// 获取标签数据
export const tagListRequest = (params?: any) => {
  return request.get('/api/v2/tag/list', {
    params
  })
}

// 添加或编辑标签
export const upsertTagRequest = (data: any) => {
  return request.post('/api/v2/tag/upsert', data)
}

//审核状态枚举
export const auditStatusEnumRequest = () => {
  return request.get<RListPairIntegerResponse>('/api/v2/customerRecord/approvalStatus/enum')
}
/**
 * R«List«Pair«Integer»»»
 */
export type RListPairIntegerResponse = {
  code?: number | null;
  count?: number | null;
  data?: PairInteger[] | null;
  ignoreColumns?: string[] | null;
  msg?: null | string;
  success?: boolean | null;
  [property: string]: any;
}

/**
 * Pair«Integer»
 */
export type PairInteger = {
  first?: null | string;
  second?: number | null;
  [property: string]: any;
}